
export const CustomElement = (config:any) => (cls:any) => {
  customElements.define(config.selector, cls)
}

